import React from 'react';
import { Typography, Box, Link, makeStyles, Theme } from '@material-ui/core';
import loadArchiverImage from './LoadArchiver.png';

const useClasses = makeStyles((theme: Theme) => ({
  link: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  image: {
    maxWidth: '100%',
    width: 600,
  },
}));

const ArchiveExplorer = () => {
  const classes = useClasses();

  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column" margin={1}>
        <Typography variant="h3" gutterBottom>
          Load archives
        </Typography>
        <Typography variant="caption" align="center" gutterBottom>
          <Link
            className={classes.link}
            href={loadArchiverImage}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className={classes.image}
              src={loadArchiverImage}
              alt="Load archiver architecture"
            />
          </Link>
          <br />
          Load archiver architecture
        </Typography>
      </Box>
    </React.Fragment>
  );
};

export default ArchiveExplorer;
